import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { ServicehotelService } from 'src/app/api/config/servicehotel.service';
import { LoadingModalComponent } from 'src/app/components/loading-modal/loading-modal.component';
import AlertifyHelper from 'src/app/utils/utils';
declare var $: any;

@Component({
  selector: 'app-servicehotel-extends',
  templateUrl: './servicehotel-extends.component.html',
  styleUrls: ['./servicehotel-extends.component.css']
})
export class ServicehotelExtendsComponent {
  @ViewChild(LoadingModalComponent) LoadingModalComponent: any;
  @Output() onSubmitEvent = new EventEmitter<string>();

  item: FormGroup;
  submitted: boolean = false;

  constructor(
    public fb: FormBuilder,
    private serviceHotelService: ServicehotelService,
    private alertifyMsg: AlertifyHelper
  ) {
    this.item = this.fb.group({
      description: ['', [Validators.required, Validators.minLength(2)]]
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  focused() {
    setTimeout(() => {
      (<any>$('#item_description')).focus();
    }, 500);
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }
    this.LoadingModalComponent.show();
    this.serviceHotelService.save(this.item.value).subscribe({
      next: (data: any) => {
        this.alertifyMsg.success('Registro realizado con éxito');
        this.onSubmitEvent.emit(data.data);
        this.LoadingModalComponent.hide();
        (<any>$('#openExtendsServiceHotel')).modal('hide');
        this.resetForm();
      }
    });
  }

  resetForm() {
    this.submitted = false;
    this.item.reset();
  }

  close() {
    this.item.reset();
  }
}

